<template>
    <div class="modal d-block" id="filterModal" tabindex="-1" aria-labelledby="filterModalLabel" v-if="isShowFilterEditor">
        <div class="modal-dialog modal-dialog-centered" style="max-width:750px">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="filterModalLabel">Filter Options</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click.prevent="handleDismiss"></button>
                </div>
                <div class="modal-body" style="overflow-y: initial;">
                    <b-filter-editor ref="filterEditor"
                                     :value="filterInfo"
                                     :fields="filterableFields"
                                     @modal-data-changed="handleDataChange"></b-filter-editor>
                </div>
                <div class="modal-footer" v-if="hasAppliedFilters">
                    <button type="button" class="btn btn-primary" :class="{'disabled':isApplyFilterDisabled}" :disabled="isApplyFilterDisabled" :aria-disabled="isApplyFilterDisabled" @click="applyFilters">Apply Filter</button>
                    <button type="button" class="btn btn-danger" @click.prevent="resetFilters">Clear Filter</button>
                </div>
                <div class="modal-footer" v-else>
                    <button type="button" class="btn btn-primary disabled" disabled="true" @click.prevent="applyFilters">Apply Filter</button>
                    <button type="button" class="btn btn-danger disabled" disabled="true" @click.prevent="resetFilters">Clear Filter</button>                    
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { defineComponent, ref, watch } from 'vue';
    import type { PropType } from 'vue';
    import BFilterEditor from "./BFilterEditor.vue";
    import {
        BFilter,
        BFilterOptions,
        BFilterOperation,
        BFilterableField,
        describeFilters,
    } from "./BFilterEditor.types";
import { deepCopy } from '@/utils';

    export default defineComponent({
        components: {
            BFilterEditor,
        },
        props: {
            isShowFilterEditor: {
                readonly: false,
                default: false,
                type: Boolean
            },
            filterOptions: {
                readonly: false,
                default: {
                    filters:[] as BFilter[]
                },
                type: Object as PropType<BFilterOptions>
            },
            filterableFields: {
                readonly: false,
                default: [],
                type: Object as PropType<BFilterableField[]>
            }
        },
        setup(props) {
            const hasAppliedFilters = ref(false);
            
            const isApplyFilterDisabled = ref(!hasAppliedFilters.value);

            if(hasAppliedFilters.value){
                isApplyFilterDisabled.value = !props.filterOptions.filters.every((it) => it.property != null && it.operation != null && it.value != null && it.property != 'id');
            }
            var filterInfo = deepCopy<BFilterOptions>(props.filterOptions);
                
            const handleDataChange = (value:BFilterOptions) => {
                
                filterInfo = value;               
                checkActionAvailability(value);
            }

            const checkActionAvailability = (value:BFilterOptions) => {
                hasAppliedFilters.value = value.filters.length > 0;       
                
                if(hasAppliedFilters.value){
                    isApplyFilterDisabled.value = !value.filters.every((it) => it.property != null && it.operation != null && it.value != null);
                }
                else {
                    isApplyFilterDisabled.value = true;
                }
            }

            checkActionAvailability(props.filterOptions);

            return {
                hasAppliedFilters,
                isApplyFilterDisabled,
                filterInfo,
                handleDataChange,
                checkActionAvailability 
            };
        },
        watch: {
            'isShowFilterEditor': function (newVal, oldVal) {
                
                if(newVal) {
                    this.filterInfo = deepCopy<BFilterOptions>(this.filterOptions); 
                    this.checkActionAvailability(this.filterInfo);
                }
            },
        },
        computed: {
            filtersDescription(): string {
                if (this.filterInfo == null) {
                    return "";
                }
                return describeFilters(
                    this.filterInfo.filters,
                    this.filterableFields
                );
            }
        },
        methods: {
            resetFilters() {
                if (this.filterInfo != null) {                    
                    this.filterInfo.filters = [];

                    this.$emit("filterChanged", this.filterInfo);
                }

                this.handleDismiss();
            },
            handleDismiss() {
                this.filterInfo.filters = [];

                this.$emit("dismissModal");
            },
            applyFilters() {
                this.hasAppliedFilters = this.filterInfo.filters.length > 0;
                
                this.$emit("filterChanged", this.filterInfo);
            },
            showFilterEditor(event: any) {
                event.preventDefault();

                this.resetFilters();
            }
        }
    });
</script>